// extracted by mini-css-extract-plugin
export default {"closedOrders":"u7r6G","table":"sisC1","cancelled":"bcktG"};